import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { formatErr } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2, KeyRound, ArrowLeft } from "lucide-react";

export default function ResetPassword() {
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const navigate = useNavigate();
    const [pw, setPw] = useState("");
    const [confirm, setConfirm] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (pw.length < 8) { toast.error("Password must be at least 8 characters."); return; }
        if (pw !== confirm) { toast.error("Passwords don't match."); return; }
        setBusy(true);
        try {
            await api.post("/auth/reset-password", { token, password: pw });
            toast.success("Password updated — please sign in.");
            navigate("/login");
        } catch (err) { toast.error(formatErr(err.response?.data?.detail)); }
        finally { setBusy(false); }
    };

    return (
        <div className="min-h-screen grid place-items-center bg-brand-bone px-4">
            <div className="w-full max-w-md bg-white border border-border rounded-2xl shadow-sm p-8" data-testid="reset-password-page">
                <img src="/procureed-logo.png" alt="ProcureEd" className="h-10 w-auto" />
                <h1 className="mt-6 text-2xl font-semibold tracking-tight text-brand-emerald">Choose a new password</h1>
                {!token ? (
                    <p className="mt-3 text-sm text-rose-600" data-testid="reset-no-token">This reset link is missing or invalid. Please request a new one.</p>
                ) : (
                    <form onSubmit={submit} className="mt-6 space-y-4">
                        <div>
                            <Label>New password</Label>
                            <Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} className="mt-1.5" placeholder="At least 8 characters" data-testid="reset-password-input" />
                        </div>
                        <div>
                            <Label>Confirm password</Label>
                            <Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-1.5" data-testid="reset-confirm-input" />
                        </div>
                        <Button type="submit" disabled={busy} className="w-full bg-brand-emerald hover:bg-brand-emeraldhover rounded-lg" data-testid="reset-submit">
                            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <><KeyRound className="h-4 w-4 mr-1.5" /> Update password</>}
                        </Button>
                    </form>
                )}
                <Link to="/login" className="mt-6 inline-flex items-center gap-1 text-sm text-brand-teal hover:text-brand-emerald" data-testid="reset-back-login"><ArrowLeft className="h-4 w-4" /> Back to sign in</Link>
            </div>
        </div>
    );
}
